// src/js/app.js

import { scrollDirection } from "./components/scrollDirection.js";

import {
	Carousel,
	Dropdown,
	Input,
	Collapse,
	NavBarCollapsible,
	NavScroll,
} from "bootstrap-italia";

(() => {
	window.addEventListener("load", () => {
		document.documentElement.classList.remove("is-loading");
		document.documentElement.classList.add("is-loaded");
	});

	new Input();
	new Carousel();
	new Dropdown();
	new Collapse();
	new NavBarCollapsible();
	new NavScroll();
	scrollDirection();
})();
